var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1011"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 19",
    cx: 17.589,
    cy: 16.4002,
    rx: 16.7355,
    ry: 15.8455,
    fill: "#9C76AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 123",
    d: "M23.0225 11.2578L12.1601 21.5425",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 124",
    d: "M23.167 21.542L12.3047 11.2573",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelBtn);
export default __webpack_public_path__ + "static/media/delBtn.0ba9d0211374cee9d6c533bacb590806.svg";
export { ForwardRef as ReactComponent };